module.exports = __webpack_public_path__ + "img/emoji-sad.d5061ebe.png";